import React from 'react'
import { Grid, Typography } from '@material-ui/core/'
import moment from 'moment'
import './index.scss'

const AddStoryMess = ({ img, time, name, goTo }) => (
  <Grid className='addStoryBox' onClick={() => goTo()}>
    <Grid className='contentBox'>
      <img className='imgStory' src={img} />
      <Grid>
        <Typography className='descText'>
          {name} asked you to tell one more story
        </Typography>
        <Typography className='time'>{moment(+time)?.startOf('minutes')?.fromNow()}</Typography>
      </Grid>
    </Grid>
  </Grid>
)

export default AddStoryMess
